// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"styles_cardContainer__2uQt1","cardSubTitle":"styles_cardSubTitle__pCdwq","instructorCode":"styles_instructorCode__3Qoe6"};